import React from 'react';
import { IonCol, IonGrid, IonImg, IonRow } from '@ionic/react';
import { StartTripModel } from '../../../models/home/StartTrip.model';
import { set_depMaxTime, set_depMinTime } from '../../../services/common.services';
import { LoadStopModel } from './loadStopUtil';
import { ICON_PATH, STOP_OFF_TEXT } from '../../../utils/constants';
import { getStopActivity } from '../../../models/stopActivity.model';
import { getAppointmentTime } from '../../../utils/formatData';

const startTripModel = new StartTripModel();
const loadStopModel = new LoadStopModel();
const depMinTime = set_depMinTime();
const depMaxTime = set_depMaxTime();

export const getLoadStops = (loadDetails: any): any[] => {
	let loadStop: any[] =
		(loadDetails && loadDetails[0].loadStop) || [];
	loadStop = loadStop.slice().sort((load1: any, load2: any) => {
		if (load1.sequenceNo && load2.sequenceNo) {
			return load1.sequenceNo - load2.sequenceNo;
		}
		if (load1.stopSequence && load2.stopSequence) {
			return load1.stopSequence - load2.stopSequence;
		}
		return 0;

	});

	return loadStop;
};

/*
 * refreshing the driver list
 * @shipment -vload details.
 * @returns - void.
 */
export const refreshDriverList = (shipment: any, props: any) => {
	const shipmentId: string = shipment?.shipmentId;
	if (!shipmentId) {
		return;
	}
	let driverLoad: any[] = props.driverLoads.filter(
		(item: any) => item.shipmentId !== shipmentId
	);
	driverLoad = driverLoad.concat({ ...shipment });
	props.refreshDriverLoads(driverLoad);
};

export const getValueFromHistoryState = (key: string, history: any) => {
	if (key) {
		return (
			history?.location?.state &&
			history.location.state[key]
		);
	}
	return null;
};

export const arrivalChange = (ARRIVAL_VALUE: string, timeZone: string, prevStopDepartedDate?: any) => {
	const currentDate = new Date(
		startTripModel.getTimeWithTimezone(timeZone)
	);
	currentDate.setMinutes(currentDate.getMinutes() + 60);

	if (ARRIVAL_VALUE && new Date(ARRIVAL_VALUE) > currentDate) {
		return true;
	} else if (prevStopDepartedDate && ARRIVAL_VALUE && new Date(prevStopDepartedDate) > new Date(ARRIVAL_VALUE)) {
		return true;
	} else {
		return false;
	}
}

export const departureChange = (DEPARTURE_VALUE:string, ARRIVAL_VALUE:string, timeZone: string)=>{
	const currentDate = new Date(
		startTripModel.getTimeWithTimezone(timeZone)
	);
	currentDate.setMinutes(currentDate.getMinutes() + depMaxTime);

	if (DEPARTURE_VALUE) {
		const _arrival = ARRIVAL_VALUE ? new Date(ARRIVAL_VALUE) : currentDate;
		const _departure = new Date(DEPARTURE_VALUE);
		let isError = false;
		if (_departure > currentDate) {
			isError = true;
		}
		_arrival.setMinutes(_arrival.getMinutes() + depMinTime);
		if (!isError && _arrival > _departure) {
			isError = true;
		}
		if (isError) {
			return true;
		} else {
			return false
		}
	} else {
		return false
	}
}

export const getIcon = (props:any,showDotteedLine:boolean,) =>{
	return props.index < props.totalStops - 1 ? (
		<>
			{props.index === 0 ? (
				<IonImg className={`stop-icon ${showDotteedLine ? 'change_origin_icon' : ''}`}
					src={ICON_PATH.origin_pointer}
				/>
			) : (
				<IonImg className="stop-icon" src={ICON_PATH.stop_pointer}
				/>
			)}
		</>
	) : (
		<IonImg
			className={`path_icon ${
				loadStopModel.isAllStopCompleted(props.loadDetails)
					? 'change_dst_icon'
					: ''
			}`}
			src={ICON_PATH.destination_pointer}
		/>
	)
}

export const showAddress = (isExpanded: boolean,stopDetail:any,props:any,isAddressSelectable:boolean=true,isCopy?:boolean) =>{
	return <IonGrid class={`complete-address2 ${isAddressSelectable && isCopy ? 'text-selectable' : ''} ${isExpanded ? 'fadein' : 'fadeout'}`} >
	<IonRow>
		<IonCol>
			{stopDetail.locationName && (
				<p>{stopDetail.locationName}</p>
			)}
			{stopDetail.addressLine1 && (
				<p> {stopDetail.addressLine1}</p>
			)}
			{stopDetail.addressLine2 && (
				<p> {stopDetail.addressLine2}</p>
			)}
		</IonCol>
		<IonCol size="4">
			<span
				onClick={() => {
					props.openSatelliteMap(stopDetail.locationName, {
						lat: stopDetail.latitude,
						lng: stopDetail.longitude
					});
				}}
				data-test='map-icon'
			>
				<IonImg
					src="/assets/icon/shipment-map-icon.svg"
					className="shipment-map-icon"
				/>
			</span>
		</IonCol>
	</IonRow>
</IonGrid>
}

export const showTime = (props:any, stopDetail:any ) =>{
	return <IonCol size="7" className="address-details2">
	<p className="origin_milehead load_header_elements">
			{(props.index !== 0 && props.index !== props.totalStops - 1) ?<>{STOP_OFF_TEXT} {props.index} :{' '}</>:''}
			{getStopActivity((stopDetail?.stopActivity) || [])}
	</p>
	<p
		className={`origin_dateTime origin-deadheadShipment2 ${
			props.expandedStop ? '' : 'origin-deadheadShipment2 '
		}`}
	>
		{stopDetail && getAppointmentTime(stopDetail)}
	</p>
</IonCol>
}